export default __webpack_public_path__ + "static/images/7f67fa3d10dab6131051e7e52f310de7.svg";